<template>
	<div id="app">
		<router-view/>
	</div>
</template>
<script>

export default {
	name: 'App'
}
</script>
<style>
@font-face {
	font-family: 'NanumSquareRoundR';
	src: url(./assets/NanumSquareRoundR.ttf) format('truetype');
}
body, p, h2 {
	margin: 0;
	padding: 0;
	overflow-x: hidden; 
	touch-action: pan-y;
}
* {
	box-sizing: border-box;
	font-family: 'NanumSquareRoundR', Avenir, Helvetica, Arial, sans-serif;
}
#app {
  text-align: center;
  color: #2c3e50;
}
</style>
